import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { acceptAll, acceptNecessaryOnly } from '../utils/consent';

const CookieBanner = ({ onAccept, onOpenSettings }) => {
  const [isVisible, setIsVisible] = useState(true);

  // Add padding to body when banner is visible - MUST be before early return
  useEffect(() => {
    if (isVisible) {
      document.body.style.paddingBottom = '80px';
    } else {
      document.body.style.paddingBottom = '0';
    }
    
    return () => {
      document.body.style.paddingBottom = '0';
    };
  }, [isVisible]);

  const handleAcceptAll = () => {
    acceptAll();
    setIsVisible(false);
    onAccept?.();
  };

  const handleNecessaryOnly = () => {
    acceptNecessaryOnly();
    setIsVisible(false);
    onAccept?.();
  };

  const handleOpenSettings = () => {
    setIsVisible(false);
    onOpenSettings?.();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/98 backdrop-blur-sm border-t border-gray-200 shadow-lg py-3 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          {/* Text Content */}
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-gray-900 mb-1">Cookies & Einstellungen</h3>
            <p className="text-xs text-gray-600">
              Wir nutzen Cookies, damit die Website zuverlässig funktioniert.{' '}
              <button
                onClick={handleOpenSettings}
                className="text-brand-green hover:text-brand-green-dark font-medium underline"
              >
                Einstellungen
              </button>
              {' '}•{' '}
              <a 
                href="/datenschutz" 
                className="text-brand-green hover:text-brand-green-dark font-medium underline"
              >
                Datenschutz
              </a>
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-row gap-2 flex-shrink-0">
            <button
              onClick={handleAcceptAll}
              className="px-4 py-2 bg-brand-green hover:bg-brand-green-dark text-white font-semibold rounded-lg transition-colors text-xs whitespace-nowrap"
            >
              Alle akzeptieren
            </button>
            <button
              onClick={handleNecessaryOnly}
              className="px-4 py-2 bg-white border border-gray-300 hover:border-gray-400 text-gray-700 font-medium rounded-lg transition-colors text-xs whitespace-nowrap"
            >
              Nur notwendige
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
